import { combineReducers } from "redux";
import loginReducer from "./login";
import profileReducer from "./profile";
import entitiesReducer from "./entities";
import uploadReducer from "./upload";
import eventReducer from "./event";
import templateReducer from "./template";
import templateCategoryReducer from "./templateCategory";
import employeeReducer from "./employee";
import communityReducer from "./community";
import campsiteReducer from "./campsite";
import cityReducer from "./city";
import neighborhoodReducer from "./neighborhood";
import gooddealReducer from "./gooddeal";
import gooddealCategoryReducer from "./gooddealCategory";
import versionReducer from "./version";
import locationReducer from "./location";
import equipmentReducer from "./equipment";
import auditReducer from "./audit";
import navReducer from "./nav";
import organizationReducer from "./organization";
import errorReducer from "./error";

// routerReducer comes from redux-first-history (see store/configure-store.js)
export default function createReducers(routerReducer) {
	const appReducer = combineReducers({
		router: routerReducer,
		profileReducer,
		entitiesReducer,
		loginReducer,
		uploadReducer,
		eventReducer,
		templateReducer,
		templateCategoryReducer,
		employeeReducer,
		communityReducer,
		campsiteReducer,
		cityReducer,
		neighborhoodReducer,
		gooddealReducer,
		gooddealCategoryReducer,
		versionReducer,
		locationReducer,
		equipmentReducer,
		auditReducer,
		navReducer,
		organizationReducer,
		errorReducer
	});
	return appReducer;
}
